<template>
  <div>
    <div class="bootstrap-wrapper">
      <div class="container">
        <DirPath :path="['Reportes', 'Estándar Lexile']" />
        <HeaderView v-bind="headerData" />

        <ReportsConfig v-if="!reports.school || !reports.course" />
        <template v-if="reports.school && reports.course">
          <div class="row my-5">
            <div class="text-center">
              <button class="button primary mx-1">
                Ver detalles por libros
              </button>
              <button class="button primary mx-1">
                Agrupar estudiantes por habilidad más descendida
              </button>
              <button class="button primary mx-1">Detalle en desafíos</button>
              <button class="button primary mx-1">Ver más</button>
            </div>
          </div>
          <HeaderReport :title="'Estándar Lexile'" />
          <div class="row text-center mt-5">
            <div class="col-12 ">
              <h4 class="text-barlow-condensed text-dark">
                Promedio del Curso: <span class="text-primary">640 L</span>
              </h4>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 px-5">
              <div class="row my-5">
                <div class="col-12 text-center">
                  <img src="https://placehold.it/40x40" />
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <h4 class="text-barlow-condensed text-primary text-center">
                    Los 5 más avanzados
                  </h4>
                </div>
              </div>
              <div class="row">
                <table class="table elevation-1">
                  <thead class="text-logo">
                    <tr>
                      <th>Nombre</th>
                      <th>Promedio</th>
                    </tr>
                  </thead>
                  <tbody class="text-primary">
                    <template v-for="(student, i) in students">
                      <tr :key="i" v-if="i < listLimit">
                        <td>{{ student.name }}</td>
                        <td>{{ student.score }}</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-md-6 px-5">
              <div class="row my-5">
                <div class="col-12 text-center">
                  <img src="https://placehold.it/40x40" />
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <h4 class="text-barlow-condensed text-secondary text-center">
                    Los 5 más descendidos
                  </h4>
                </div>
              </div>
              <div class="row">
                <table class="table elevation-1">
                  <thead class="text-logo">
                    <tr>
                      <th>Nombre</th>
                      <th>Promedio</th>
                    </tr>
                  </thead>
                  <tbody class="text-primary">
                    <template v-for="(student, i) in students">
                      <tr :key="i" v-if="i < listLimit">
                        <td>{{ student.name }}</td>
                        <td>{{ student.score }}</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 text-center">
              <div
                v-if="listLimit < 6"
                @click="setLimit(10)"
                class="elevation-1 text-primary cirlce-button mx-auto"
              >
                <i class="fas fa-plus"></i>
              </div>
              <div
                v-if="listLimit > 5"
                @click="setLimit(5)"
                class="elevation-1 text-secondary cirlce-button mx-auto"
              >
                <i class="fas fa-minus"></i>
              </div>
              <span v-if="listLimit < 6" class="text-primary">Ver más</span>
              <span v-if="listLimit > 5" class="text-primary">Ver menos</span>
            </div>
          </div>
        </template>
        <div class="row">
          <FooterComponent />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DirPath from "@/components/DirPath";
import FooterComponent from "@/components/Footer";
import HeaderReport from "@/components/HeaderReport";
import HeaderView from "@/components/HeaderView";
import ReportsConfig from "@/components/ReportsConfig";

export default {
  name: "lexileStandard",
  components: {
    DirPath,
    FooterComponent,
    HeaderReport,
    HeaderView,
    ReportsConfig,
  },
  data() {
    let { secCol } = this.$store.getters;

    return {
      headerData: {
        title: "Estándar Lexile",
        subTitle: "",
        body:
          "Visualiza el estado actual de tus estudiantes de acuerdo al estándar más usado en materia de capacidad lectora",
        img: require("@/assets/images/Componente 32 – 1.svg"),
      },
      secCol,
      students: [
        { name: "Pedro", score: 15 },
        { name: "Pedro", score: 15 },
        { name: "Pedro", score: 15 },
        { name: "Pedro", score: 15 },
        { name: "Pedro", score: 15 },
        { name: "Pedro", score: 15 },
        { name: "Pedro", score: 15 },
        { name: "Pedro", score: 15 },
        { name: "Pedro", score: 15 },
        { name: "Pedro", score: 15 },
        { name: "Pedro", score: 15 },
        { name: "Pedro", score: 15 },
        { name: "Pedro", score: 15 },
        { name: "Pedro", score: 15 },
        { name: "Pedro", score: 15 },
      ],
      listLimit: 5,
    };
  },
  methods: {
    setLimit(len) {
      this.listLimit = len;
    },
  },
  computed: {
    ...mapState(["reports"]),
  },
  mounted() {
    this.getReportData();
  },
};
</script>
